import VouchQualifyForm from "@/components/forms/vouch-qualify-form";
import { Separator } from "@/components/ui/separator";
import UserProfile from "@/components/user-profile";
import type { ProfileViewModel } from "@/lib/types";
import { useOutletContext } from "react-router";

const QualifyForVouch = () => {
  const profile = useOutletContext<ProfileViewModel>();

  return (
    <section className="animate-screen relative z-10 mx-auto flex max-w-4xl  flex-1 flex-col  gap-5  px-6 py-24 sm:gap-10">
      <UserProfile profile={profile} />
      <Separator />
      {/* <VouchFormHeader
        title="Before we begin"
        subtitle={`Help us keep ${profile?.FirstName}'s profile honest and the community safe.`}
      /> */}
      <VouchQualifyForm voucheeName={profile?.FirstName} />
    </section>
  );
};

export default QualifyForVouch;
